import React from 'react'

const CalendarPlusIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.83152 13.5761V11.6033H7.8587V10.288H9.83152V8.31522H11.1467V10.288H13.1196V11.6033H11.1467V13.5761H9.83152ZM1.94022 12.2609C1.57853 12.2609 1.26891 12.1321 1.01135 11.8745C0.753782 11.617 0.625 11.3073 0.625 10.9457V3.05435C0.625 2.69267 0.753782 2.38305 1.01135 2.12548C1.26891 1.86792 1.57853 1.73914 1.94022 1.73914H2.59783V0.42392H3.91304V1.73914H7.8587V0.42392H9.17391V1.73914H9.83152C10.1932 1.73914 10.5028 1.86792 10.7604 2.12548C11.018 2.38305 11.1467 2.69267 11.1467 3.05435V7.06577C10.9275 7.03289 10.7083 7.01645 10.4891 7.01645C10.2699 7.01645 10.0507 7.03289 9.83152 7.06577V5.68479H1.94022V10.9457H6.54348C6.54348 11.1649 6.55992 11.3841 6.5928 11.6033C6.62568 11.8225 6.68596 12.0417 6.77364 12.2609H1.94022Z'
      fill='currentColor'
    />
  </svg>
)

export default CalendarPlusIcon
